d<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
        color="blue accent-3"
        dark
        extended
        flat
        class="toolbar__fixed"
      >
      </v-toolbar>

      <v-dialog
        v-model="dialogSerCisla"
        persistent
        max-width="900px"
        transition="dialog-transition"
        v-if="dialogSerCisla"
      >
        <v-card flat class="no__radius pa-0 gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
          <v-card-title class="pl-0 pt-0">
            <h2>Seznam sériových čísel</h2>
          </v-card-title>
          <div class="gui-flex gui-flex-rows">
            <v-card color="grey lighten-4 elevation-0" class="pa-0" :class="{'pt-3 pl-3 pr-3 pb-1' : $vuetify.breakpoint.smAndUp}">
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md4>
                    <p class="grey--text caption mb-1">Název produktu:</p> <strong><router-link :to="{ path: '/produkty/'+produktDetail.id }">{{produktDetail.nazev_produktu}}</router-link></strong>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <p class="grey--text caption mb-1">Blokováno (ks):</p> <strong>{{produktDetail.blokovano | formatInt}}</strong>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <p class="grey--text caption mb-1">Volné (ks):</p> <strong>{{produktDetail.volne | formatInt}}</strong>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-4">
                  <v-flex xs12>
                    <div class="table-border__radius elevation-1">
                      <v-data-table
                        :headers="headersSeriovaCisla"
                        :items="itemsSeriovaCisla"
                        :loading="loadingSerCisla"
                        :pagination.sync="paginationSerCisla"
                        :total-items="paginationSerCisla.totalItems"
                        :rows-per-page-items="[ 25, 50, 100, 200 ]"
                      >
                        <template slot="items" slot-scope="props">
                          <td>{{ props.item.seriove_cislo }}</td>
                          <td class="text-center">
                            <v-btn color="primary" class="elevation-0">
                            <v-icon small class="mr-2">card_giftcard</v-icon> Předat jako dárek</v-btn>
                          </td>
                        </template>
                      </v-data-table>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </div>
          <v-card-actions class="pa-0">
            <v-spacer></v-spacer>
            <v-btn color="grey lighten-3 mt-3 mr-0 elevation-0" @click="dialogSerCisla=false">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogPrijemka"
        persistent
        max-width="900px"
        transition="dialog-transition"
        v-if="dialogPrijemka"
      >
        <v-card flat class="no__radius pa-0 gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
          <v-card-title class="pl-0 pt-0">
            <h2>Obecná příjemka na sklad</h2>
          </v-card-title>
          <div class="gui-flex gui-flex-rows">
            <v-form v-model="prijemka_valid" lazy-validation ref="prijemkaForm">
              <v-card color="grey lighten-4 elevation-0" class="pa-0" :class="{'pt-3 pl-3 pr-3 pb-1' : $vuetify.breakpoint.smAndUp}">
                <v-card-text>
                  <v-layout row wrap>
                    <!-- <v-flex xs12 sm6 md4>
                      <datepicker label="Datum" class="mb-2" :rules="true" v-model="prijemka_datum"></datepicker>
                    </v-flex> -->

                    <v-flex xs12 sm6 md8>
                      <productsearch label="Vyhledat produkt" class="mb-2" style="margin-left:0!important;margin-right:0!important" v-model="prijemka_produkt_id" @changed="(e) => { prijemkaAddProdukt(e); }" clearOnSelect></productsearch>
                    </v-flex>

                    <v-flex xs12 class="mb-5">
                      <v-data-table
                        :headers="headersPrijemka"
                        :items="itemsPrijemka"
                        :pagination.sync="pagination"
                        :total-items="pagination.totalItems"
                        :rows-per-page-items="[25, 50, 100, 200]"
                        item-key="row_id"
                      >
                        <template slot="items" slot-scope="props">
                          <td>
                            <router-link :to="{ path: '/produkty/' + props.item.id }" target="_blank">
                              {{ props.item.nazev }}
                            </router-link>
                          </td>
                          <td>
                            <v-text-field
                              label="Zadejte sériové číslo"
                              id="id"
                              v-if="props.item.vyzadovat_seriove_cislo"
                              v-model="props.item.seriove_cislo"
                              :rules="rulesRequired"
                            ></v-text-field>
                          </td>
                          <td>
                            <v-text-field
                              label="Množství"
                              id="id"
                              v-if="!props.item.vyzadovat_seriove_cislo"
                              v-model="props.item.mnozstvi"
                              :rules="rulesRequiredMoreThanZero"
                            ></v-text-field>
                          </td>
                          <td class="text-xs-right">
                            <v-btn dark depressed icon flat fab color="red" class="ma-0" @click="prijemka_produkt=props.item;dialogDeletePrijemka=true">
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </td>
                        </template>
                      </v-data-table>
                    </v-flex>

                    <v-flex xs12>
                      <v-textarea
                        label="Poznámka"
                        height="30"
                        class="mt-3"
                        auto-grow
                        :rules="rulesRequired"
                        v-model="prijemka_poznamka"
                      ></v-textarea>
                    </v-flex>

                    <v-flex xs12>
                      <p class="bold error--text mt-3 mb-0">Zaúčtování ve Flexibee je třeba udělat ručně.</p>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-form>
          </div>
          <v-card-actions class="pa-0 mt-3">
            <v-spacer></v-spacer>
            <v-btn dark depressed color="green" @click="savePrijemka();" :loading="saving">Uložit</v-btn>
            <v-btn color="grey lighten-3 elevation-0" @click="dialogPrijemka=false" v-if="!saving">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogVydejka"
        persistent
        max-width="900px"
        transition="dialog-transition"
        v-if="dialogVydejka"
      >
        <v-card flat class="no__radius pa-0 gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
          <v-card-title class="pl-0 pt-0">
            <h2>Obecná výdejka ze skladu</h2>
          </v-card-title>
          <div class="gui-flex gui-flex-rows">
            <v-form v-model="vydejka_valid" lazy-validation ref="vydejkaForm">
              <v-card color="grey lighten-4 elevation-0" class="pa-0" :class="{'pt-3 pl-3 pr-3 pb-1' : $vuetify.breakpoint.smAndUp}">
                <v-card-text>
                  <v-layout row wrap>
                    <!-- <v-flex xs12 sm6 md4>
                      <datepicker label="Datum" class="mb-2" v-model="vydejka_datum" :rules="true"></datepicker>
                    </v-flex> -->

                    <v-flex xs12 sm6 md8>
                      <productsearch label="Vyhledat produkt" class="mb-2" style="margin-left:0!important;margin-right:0!important" v-model="vydejka_produkt_id" @changed="(e) => { vydejkaAddProdukt(e); }" clearOnSelect></productsearch>
                    </v-flex>

                    <v-flex xs12 class="mb-5">
                      <v-data-table
                        :headers="headersPrijemka"
                        :items="itemsVydejka"
                        :pagination.sync="pagination"
                        :total-items="pagination.totalItems"
                        :rows-per-page-items="[25, 50, 100, 200]"
                        item-key="row_id"
                      >
                        <template slot="items" slot-scope="props">
                          <td>
                            <router-link :to="{ path: '/produkty/' + props.item.id }" target="_blank">
                              {{ props.item.nazev }}
                            </router-link>
                          </td>
                          <td>
                            <seriovecislosearch v-if="props.item.vyzadovat_seriove_cislo" v-model="props.item.seriove_cislo" :produkt="props.item.id" :rules="rulesRequired"></seriovecislosearch>
                          </td>
                          <td>
                            <v-text-field
                              label="Množství"
                              id="id"
                              v-if="!props.item.vyzadovat_seriove_cislo"
                              v-model="props.item.mnozstvi"
                              :rules="rulesRequiredMoreThanZero"
                            ></v-text-field>
                          </td>
                          <td class="text-xs-right">
                            <v-btn dark depressed icon flat fab color="red" class="ma-0" @click="vydejka_produkt=props.item;dialogDeleteVydejka=true">
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </td>
                        </template>
                      </v-data-table>
                    </v-flex>

                    <v-flex xs12>
                      <v-textarea
                        label="Poznámka"
                        height="30"
                        class="mt-3"
                        auto-grow
                        :rules="rulesRequired"
                        v-model="vydejka_poznamka"
                      ></v-textarea>
                    </v-flex>

                    <v-flex xs12>
                      <p class="bold error--text mt-0 mb-0">Zaúčtování ve Flexibee je třeba udělat ručně.</p>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-form>
          </div>
          <v-card-actions class="pa-0 mt-3">
            <v-spacer></v-spacer>
            <v-btn dark depressed color="green" @click="saveVydejka" :loading="saving">Uložit</v-btn>
            <v-btn color="grey lighten-3 elevation-0" @click="dialogVydejka=false" v-if="!saving">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogDeletePrijemka"
        persistent
        max-width="500px"
        transition="dialog-transition"
        v-if="dialogDeletePrijemka"
      >
        <v-card class="no__padding">
          <v-card-title>
            <h2>Smazat příjemku</h2>
          </v-card-title>
          <v-card-text class="pt-0 pb-2">
            <p>Opravdu chcete smazat produkt {{ prijemka_produkt.nazev }} z příjemky?</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red elevation-0" dark @click="itemsPrijemka.splice(itemsPrijemka.indexOf(prijemka_produkt), 1); dialogDeletePrijemka = false;"><v-icon class="mr-2">delete</v-icon> Smazat</v-btn>
            <v-btn color="grey lighten-3 elevation-0" @click="dialogDeletePrijemka=false">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogDeleteVydejka"
        persistent
        max-width="500px"
        transition="dialog-transition"
        v-if="dialogDeleteVydejka"
      >
        <v-card class="no__padding">
          <v-card-title>
            <h2>Smazat výdejku</h2>
          </v-card-title>
          <v-card-text class="pt-0 pb-2">
            <p>Opravdu chcete smazat produkt {{ vydejka_produkt.nazev }} z výdejky?</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red elevation-0" dark @click="itemsVydejka.splice(itemsVydejka.indexOf(vydejka_produkt), 1); dialogDeleteVydejka = false;"><v-icon class="mr-2">delete</v-icon> Smazat</v-btn>
            <v-btn color="grey lighten-3 elevation-0" @click="dialogDeleteVydejka=false">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap class="mb-3">
              <v-flex xs12 sm6>
                <h3>Sklad hotových produktů</h3>
              </v-flex>
            </v-layout>
            <v-layout row wrap align-center class="mt-3">
              <v-flex xs12 sm4 md4 lg2>
                <sklady all v-model="sklad"></sklady>
              </v-flex>
              <v-flex xs12 sm8 md8 lg4>
                <productsearch label="Hledaný produkt" v-model="produkt"></productsearch>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex shrink :class="{'mb-3' : $vuetify.breakpoint.xs, 'pr-3' : $vuetify.breakpoint.smAndUp, 'xs12 sm6' : $vuetify.breakpoint.smAndDown}">
                <v-btn dark depressed color="primary" class="ma-0" @click="prijemkaAddClick();" :class="{'v-btn--block' : $vuetify.breakpoint.smAndDown}"><v-icon class="mr-2">add</v-icon>
                  Přidat obecnou příjemku</v-btn>
              </v-flex>
              <v-flex shrink :class="{'xs12 sm6' : $vuetify.breakpoint.smAndDown}">
                <v-btn dark depressed color="primary" class="ma-0" @click="vydejkaAddClick();" :class="{'v-btn--block' : $vuetify.breakpoint.smAndDown}"><v-icon class="mr-2">add</v-icon> Přidat obecnou výdejku</v-btn>
              </v-flex>
              <v-flex class="fill-width">
                <!--<date-range-picker
                      @update="console.log(value)"
                      :locale-data="locale"
                    >
                </date-range-picker>-->
              </v-flex>
            </v-layout>
            <div class="table-border__radius elevation-1">
              <v-data-table
                :headers="headers"
                :items="items"
                :pagination.sync="pagination"
                :total-items="pagination.totalItems"
                :rows-per-page-items="[25, 50, 100, 200]"
              >
                <template slot="items" slot-scope="props">
                  <td><router-link :to="{ path: '/produkty/'+props.item.produkt.id }">{{props.item.nazev_produktu}}</router-link></td>
                  <td class="text-xs-right">{{ props.item.aktualni_stav }}</td>
                  <td class="text-xs-right">{{ props.item.blokovano }}</td>
                  <td class="text-xs-right">{{ props.item.volne }}</td>
                  <td class="text-xs-right">{{ props.item.k_blokaci }}</td>
                  <td class="text-xs-right">
                    <router-link :to="{ path: '/sklad/pohyby-ve-skladu/' + props.item.produkt.id }">
                      <v-btn color="primary" class="elevation-0">
                      <v-icon small class="mr-2">swap_horiz</v-icon> Pohyby</v-btn>
                    </router-link>
                    <v-btn color="primary" @click="openDetail(props.item)" class="elevation-0">
                    <v-icon small class="mr-2">sort</v-icon> Sériová čísla</v-btn>
                  </td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      dialogSerCisla: false,
      dialogPrijemka: false,
      dialogVydejka: false,
      dialogDeletePrijemka: false,
      dialogDeleteVydejka: false,
      prijemka_valid: true,
      vydejka_valid: true,
      headers: [
        { text: 'Produkt', value: 'nazev_produktu' },
        { text: 'Množství na skladě', value: 'aktualni_stav', align: 'right' },
        { text: 'Blokováno', value: 'blokovano', align: 'right' },
        { text: 'Volné množství', value: 'volne', sortable: false, align: 'right' },
        { text: 'Množství k blokaci', value: 'volne', sortable: false, align: 'right' },
        { text: 'Zobrazit', value: null, sortable: false, align: 'right' }
      ],
      headersSeriovaCisla: [
        { text: 'Sériové číslo', value: 'seriove_cislo' },
        { text: 'Akce', value: null, sortable: false, align: 'center' }
      ],
      headersPrijemka: [
        { text: 'Název produktu', value: 'nazev' },
        { text: 'Sériové číslo', value: 'seriove_cislo' },
        { text: 'Počet ks', value: 'mnozstvi' },
        { text: 'Smazat', value: null, sortable: false, align: 'right' },
      ],
      itemsPrijemka: [],
      prijemka_datum: null,
      prijemka_produkt_id: null,
      prijemka_produkt: null,
      prijemka_poznamka: null,
      itemsVydejka: [],
      vydejka_datum: null,
      vydejka_produkt_id: null,
      vydejka_produkt: null,
      vydejka_poznamka: null,
      items: [],
      itemsSeriovaCisla: [],
      loadingTable: true,
      search: "",
      timeout: null,
      counter: 0,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        sortBy: "id",
        totalItems: 0
      },
      sklad: null,
      produkt: null,
      produktDetail: null,
      loadingSerCisla: false,
      searchSerCisla: "",
      timeoutSerCisla: null,
      counterSerCisla: 0,
      paginationSerCisla: {
        descending: false,
        page: 1,
        rowsPerPage: 25,
        sortBy: "id",
        totalItems: 0
      },
      rulesRequired: [ (v) => !!v || "Pole je vyžadováno" ],
      rulesRequiredMoreThanZero: [
        (v) => !!v && v > 0 || "Pole je vyžadováno"
      ],
      saving: false
    }
  },
  mounted: function() {
    window.MenuListener.show();
    this.load();
  },
  watch: {
  	pagination: {
  		handler: function(newValue) {
  			this.load();
  		},
  		deep: true
  	},
    sklad () {
      this.load();
  	},
    produkt () {
      this.load();
    },
    paginationSerCisla () {
      this.loadSerCisla();
    }
  },
  methods: {
    queryList: function() {
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.pagination.page = 1;
        this.load();
      }.bind(this), 200)
    },
    load: function() {
      this.counter++;
      this.loadingTable = true;
      window.API.post("sklady/search", {
        pagination: this.pagination,
        s: this.search,
        echo: this.counter,
        sklad: this.sklad,
        produkt: this.produkt
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        this.items.replace(body.data);
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loading = false;
        this.loadingTable = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    loadSerCisla: function() {
      this.counterSerCisla++;
      this.loadingSerCisla = true;
      this.itemsSeriovaCisla = [];
      window.API.post("sklady/seriova-cisla/search", {
        pagination: this.paginationSerCisla,
        s: this.search,
        echo: this.counterSerCisla,
        sklad: this.sklad,
        produkt: this.produktDetail.produkt.id
      }).then(function(body) {
        if (this.counterSerCisla != body.echo)
          return;
        this.itemsSeriovaCisla.replace(body.data);
        this.paginationSerCisla.sortBy = body.sort.sortBy;
        this.paginationSerCisla.descending = body.sort.descending;
        this.paginationSerCisla.page = body.sort.page;
        this.paginationSerCisla.rowsPerPage = body.sort.rowsPerPage;
        this.paginationSerCisla.totalItems = body.sort.totalItems;
        this.loadingSerCisla = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    openDetail (v) {
      this.produktDetail = v;
      this.dialogSerCisla = true;
      this.loadSerCisla();
    },
    prijemkaAddClick () {
      this.prijemka_datum = parseInt(new Date().getTime() / 1000);
      this.itemsPrijemka = [];
      this.prijemka_poznamka = null;
      this.prijemka_produkt_id = null;
      this.dialogPrijemka = true;
    },
    prijemkaAddProdukt(e) {
      if (e == null)
        return;
      var v = window.th.copy(e);
      v.row_id = window.th.makeid();
      v.seriove_cislo = null;
      v.mnozstvi = null;
      this.itemsPrijemka.push(v);
      this.prijemka_produkt_id = null;
    },
    savePrijemka () {
      if (this.$refs.prijemkaForm.validate() && this.itemsPrijemka.length > 0) {
        this.saving = true;
        window.API.post("sklady/prijemka", {
          datum: this.prijemka_datum,
          produkty: this.itemsPrijemka.map((e) => {
            return {
              id: e.id,
              seriove_cislo: e.seriove_cislo,
              mnozstvi: e.vyzadovat_seriove_cislo ? 1 : parseInt(e.mnozstvi)
            };
          }),
          poznamka: this.prijemka_poznamka
        }).then((b) => {
          if (b.success) {
            this.saving = false;
            this.dialogPrijemka = false;
            this.load();
          }
          else {
            this.saving = false;
          }
        }).catch((e) => {
          this.saving = false;
          console.log(e);
        })
      }
    },
    vydejkaAddClick () {
      this.vydejka_datum = parseInt(new Date().getTime() / 1000);
      this.itemsVydejka = [];
      this.vydejka_poznamka = null;
      this.vydejka_produkt_id = null;
      this.dialogVydejka = true;
    },
    vydejkaAddProdukt(e) {
      if (e == null)
        return;
      var v = window.th.copy(e);
      v.row_id = window.th.makeid();
      v.seriove_cislo = null;
      v.mnozstvi = null;
      this.itemsVydejka.push(v);
      this.vydejka_produkt_id = null;
    },
    saveVydejka () {
      if (this.$refs.vydejkaForm.validate() && this.itemsVydejka.length > 0) {
        this.saving = true;
        window.API.post("sklady/vydejka", {
          datum: this.vydejka_datum,
          produkty: this.itemsVydejka.map((e) => {
            return {
              id: e.id,
              seriove_cislo: e.seriove_cislo,
              mnozstvi: e.vyzadovat_seriove_cislo ? 1 : parseInt(e.mnozstvi)
            };
          }),
          poznamka: this.vydejka_poznamka
        }).then((b) => {
          if (b.success) {
            this.saving = false;
            this.dialogVydejka = false;
            this.load();
          }
          else {
            this.saving = false;
          }
        }).catch((e) => {
          this.saving = false;
          console.log(e);
        })
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Sklady/SkladHotovychProduktu.vue